import { supabase } from "../service/SupabaseConnector"
import fileNameValidator from "./FileNameValidator";

async function uploadHelper(file:File, folder: string){
    const fileName = `${Date.now()}_${fileNameValidator(file.name)}`
    const filePath = `${folder}/${fileName}`
    const response = await supabase.storage.from('images').upload(filePath, file)
    return response;
}
export default uploadHelper;
